import React, { forwardRef } from 'react';
import classnames from "classnames";
import IBuildrProps from '../../utilities/IBuildrProps';
import ModalTrigger from '../Modals/ModalTrigger';
import ModalEnum from '../Modals/BaseModal/ModalEnum';
import { AutomationTestIdElementType, AutomationTestIdFeature, createDataTestId } from '../../utilities/automation';

interface IBarItemProps extends IBuildrProps {
    label: string;
    link: string;
}

const BarItem = forwardRef(({ cmsId, editorClassObj, className, label, link }: IBarItemProps, ref: any) => {

    function onClick(ev) {
        if (!!cmsId) {
            ev.preventDefault();
        }
    }
    function BarLink(props) {
        return (
            <a
                data-test-id={createDataTestId({feature: AutomationTestIdFeature.HERO, element: AutomationTestIdElementType.COLLECTION_ITEM, specifier: "suggestion"})}
                data-id={cmsId}
                className={classnames(editorClassObj, className, "link-item mx-2 mb-3 mb-xxl-0")}
                ref={ref}
                href={link}
                onClick={props.onClick}>{label}</a>
        );
    }
    if (link === '#login' && !cmsId) {
        return (
          <ModalTrigger modal={ModalEnum.Login}>
            <BarLink />
          </ModalTrigger>
        );
    }
    return <BarLink onClick={onClick} />;
});

export default BarItem;
